import { Action, createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { NetLossLimit } from "../betting-limit.model";

import {
	getNetlossLimitConfirmationSuccess,
	updateNetLossLimitConfirmationSuccess,
} from "./netloss-limit-confirmation.action";

const INITIAL_STATE: NetLossLimit = {
	limitId: undefined,
	limitPeriod: undefined,
	limitType: undefined,
	status: undefined,
	limitValue: 0,
	period: 0,
};

export const netLossConfirmationReducer = createReducer<NetLossLimit, Action>(
	INITIAL_STATE,
	on(getNetlossLimitConfirmationSuccess, (state, { payload }) => updateState(state, payload)),
	on(updateNetLossLimitConfirmationSuccess, (state, { payload }) => updateState(state, { status: payload.status }))
);
